import axios from "axios";
import routes from "../assets/apiRoutes.json";
let accessToken = "";
class TFYPManager {
    constructor(_accessToken) {
        accessToken = _accessToken;
        this.apiBaseUrl = `${window._env_.REACT_APP_APIS}`;
        this.CurrentFP = 0;
        this.CurrentFY = 0;
        this.LastDate = new Date().setHours(0, 0, 0, 0);
        this.initializeData();
        this.FisY = 0;
        this.FisP = 0;
    }
    async initializeData() {
        try {
            const { FiscalPeriod, FiscalYear } = await this.getFiscalPeriodYear(new Date());
            this.CurrentFP = FiscalPeriod;
            this.CurrentFY = FiscalYear;
        } catch (error) {
            console.error('Error fetching getFiscalPeriodYear:', error);
        }
    }
    async getFiscalPeriodYear(ADate) {
        try {
            let request = { date: ADate };
            const response = await axios.post(`${this.apiBaseUrl}/${routes.FiscalYearPeriodManager.GetFiscalPeriodYear}`, JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            const { item1: FiscalPeriod, item2: FiscalYear } = response.data.resultdata;
            return { FiscalPeriod, FiscalYear };
        } catch (error) {
            console.error("Error fetching fiscal period year:", error);
            return { FiscalPeriod: null, FiscalYear: null };
        }
    }
    setfeildcaption(caption) {
        this.fieldcaption = caption;
    }
    async isDateAllowed2(moduleName, aDate, fieldCaption) {
        let msg, lblTextHeading;
        let numPrevYearPer = 0
        let dateStatus;
        let [fp, fy] = await this.getCurrentFiscalPeriodYear();
        if (fp == 0 && fy == 0) {
            msg = 'Fiscal Periods for current Fiscal Year are not defined. ' +
                'You must define your Fiscal Periods for the current Fiscal Year before you can commit this record.' +
                'Please, Exit ABECAS Insight and login again after you have created the new fiscal year.';
            return {
                Success: true,
                Message: msg,
                isFiscalYearPopUpNeeded: false
            };
        }
        dateStatus = await this.getDateStatus(moduleName, aDate);
        switch (dateStatus) {
            case 'dsOK':
                {
                    return {
                        Success: true,
                        Message: msg,
                        isFiscalYearPopUpNeeded: false
                    };
                }
            case 'dsAllowedRange':
                lblTextHeading = 'The fiscal Period/Year for this transaction ' +
                    'is different than the current fiscal Period/Year. ' +
                    'You can change the date in the transaction or the Fiscal Period/Year here.';
                break;
            case 'dsBad':
                lblTextHeading = 'Note: The displayed Fiscal Year/Period has been adjusted to ' +
                    'fit within this module allowable ranges.';
                break;
        }
        const [maxPriorPeriods, maxPeriodsInPriorYear, maxFuturePeriods] = await this.getParams(moduleName);
        this.maxPriorPeriods = maxPriorPeriods;
        this.maxPeriodsInPriorYear = maxPeriodsInPriorYear;
        this.maxFuturePeriods = maxFuturePeriods;
        [fp, fy] = await this.getCurrentFiscalPeriodYear();
        numPrevYearPer = await this.getPeriodsNum(fy - 1);
        let [MinPeriod, MinYear, MaxPeriod, MaxYear] = await this.getBounds(moduleName);
        let isPostPeriod = await this.postPeriod(moduleName);
        return {
            Success: true,
            Message: msg,
            isFiscalYearPopUpNeeded: true,
            FieldCaption: fieldCaption,
            lblTextHeading: lblTextHeading,
            TransDate: aDate,
            MaxPriorPeriods: maxPriorPeriods,
            MaxPeriodsInPriorYear: maxPeriodsInPriorYear,
            NumPrevYearPer: numPrevYearPer,
            MinPeriod: MinPeriod,
            MinYear: MinYear,
            MaxPeriod: MaxPeriod,
            MaxYear: MaxYear,
            FiscalPeriod: fp,
            FiscalYear: fy,
            IsPostPeriod: isPostPeriod
        };
    }
    async checkFiscalYearPeriod(ModuleName, ADate, iCaption = 0) {
        const captions = ["", "Invoice Date", "Check Date", "Alt AC Date", "AP Commit"];
        const Caption = captions[iCaption] || "";
        const result = await this.isDateAllowed2(ModuleName, ADate, Caption);
        return result;
    }

    async getCurrentFiscalPeriodYear() {
        if (this.LastDate == new Date().setHours(0, 0, 0, 0)) {
            return [this.CurrentFP, this.CurrentFY, true];
        } else {
            const { FiscalPeriod, FiscalYear } = await this.getFiscalPeriodYear(new Date());
            this.CurrentFP = FiscalPeriod;
            this.CurrentFY = FiscalYear;
            this.LastDate = new Date().setHours(0, 0, 0, 0);
            return [this.CurrentFP, this.CurrentFY, false];
        }
    }
    async getBounds(ModuleName) {
        const [Pc, Yc] = await this.getCurrentFiscalPeriodYear();
        const [MaxPriorPeriods, MaxPeriodsInPriorYear, FuturePeriods] = await this.getParams(ModuleName);
        let MinYear, MinPeriod, NumPrevYearPer;

        if (Pc <= MaxPriorPeriods && MaxPeriodsInPriorYear > 0 && (await this.getPeriodsNum(Yc - 1)) > 0) {
            MinYear = Yc - 1;
        } else {
            MinYear = Yc;
        }
        NumPrevYearPer = await this.getPeriodsNum(Yc - 1);
        MinPeriod = Pc - MaxPriorPeriods + NumPrevYearPer;
        if (MinPeriod < NumPrevYearPer - MaxPeriodsInPriorYear) {
            MinPeriod = NumPrevYearPer - MaxPeriodsInPriorYear + 1;
        }
        if (MinPeriod < 1) {
            MinPeriod = 1;
        }
        let [FP, FY] = await this.moveForward(Pc, Yc, FuturePeriods);
        let MaxPeriod = FP;
        let MaxYear = FY;
        return [MinPeriod, MinYear, MaxPeriod, MaxYear];
    }
    async getDateStatus(AModuleName, ADate) {
        const { FiscalYear, FiscalPeriod } = await this.getFiscalPeriodYear(ADate);
        const [FPc, FYc] = await this.getCurrentFiscalPeriodYear();

        if (FPc == FiscalPeriod && FYc == FiscalYear) {
            return "dsOK";
        }
        if (await this.isDateAllowed(AModuleName, ADate)) {
            return "dsAllowedRange";
        } else {
            return "dsBad";
        }
    }

    async getParams(moduleName) {
        try {
            let request = { module: moduleName };
            const response = await axios.post(`${this.apiBaseUrl}/${routes.FiscalYearPeriodManager.GetParams}`, JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data) {
                return [
                    response.data.resultdata.item1, //MaxPriorPeriods
                    response.data.resultdata.item2, //MaxPeriodsInPriorYear
                    response.data.resultdata.item3 //FuturePeriods
                ];
            }
        } catch (error) {
            console.error("Error fetching period limits:", error);
        }
        return [0, 0, 0];
    }

    async getPeriodsNum(year) {
        try {
            let request = { year: year };
            const response = await axios.post(`${this.apiBaseUrl}/${routes.FiscalYearPeriodManager.GetPeriodsNum}`, JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return response.data.resultdata;
        } catch (error) {
            console.error("Error fetching periods number:", error);
            return 0;
        }
    }

    async getFiscalPeriodYearByModule(aModule, aFiscalPeriod, aFiscalYear) {
        try {
            let request = {
                module: aModule,
                year: aFiscalYear,
                period: aFiscalPeriod
            }
            const response = await axios.post(`${this.apiBaseUrl}/${routes.FiscalYearPeriodManager.GetFiscalPeriodYearByModule}`, JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data) {
                return {
                    FiscalYear: response.data.resultdata.item1,
                    FiscalPeriod: response.data.resultdata.item2
                };
            }
        } catch (error) {
            console.error("Error fetching fiscal year period by module:", error);
        }
        return { FiscalYear: null, FiscalPeriod: null };
    }


    async isDateAllowed(ModuleName, ADate) {
        try {
            let request = {
                module: ModuleName,
                date: ADate
            }
            const response = await axios.post(`${this.apiBaseUrl}/${routes.FiscalYearPeriodManager.IsDateAllowed}`, JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
            return response.data.resultdata;
        } catch (error) {
            console.error("Error checking if date is allowed:", error);
            return false;
        }
    }

    async moveForward(FP, FY, PeriodsNum) {
        let Stop = false;
        let PerNum = await this.getPeriodsNum(FY);

        while (!Stop) {
            let Rest = PerNum - FP + 1;
            if (Rest <= PeriodsNum) {
                PeriodsNum -= Rest;
                FY++;
                FP = 1;
                PerNum = await this.getPeriodsNum(FY);

                if (PerNum == 0) {
                    FY--;
                    FP = await this.getPeriodsNum(FY);
                    Stop = true;
                }
            } else {
                FP += PeriodsNum;
                Stop = true;
            }
        }
        return [FP, FY];
    }
    async postPeriod(module) {
        try {
            let request = { module: module };
            const response = await axios.post(`${this.apiBaseUrl}/${routes.FiscalYearPeriodManager.PostPeriod}`, JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            return response.data.resultdata;
        } catch (error) {
            console.error("Error fetching Post Period:", error);
            return 0;
        }
    }
}

export default TFYPManager;